"use strict";const i=function(){let e=()=>{},r=()=>{};return{$promise:new Promise((t,s)=>{e=t,r=s}),resolve:e,reject:r}}();exports.InitPromiseDeferred=i;
